// extracted by mini-css-extract-plugin
export var avatarContainer = "_8p-0";
export var avatarTypingWave = "_8p-i";
export var gray = "_8p-f";
export var green = "_8p-c";
export var icon = "_8p-9";
export var image = "_8p-1";
export var lg = "_8p-6";
export var md = "_8p-5";
export var presenceDot = "_8p-b";
export var red = "_8p-d";
export var sm = "_8p-4";
export var status = "_8p-a";
export var typingDot = "_8p-h";
export var typingPill = "_8p-g";
export var xl = "_8p-7";
export var xs = "_8p-3";
export var xxl = "_8p-8";
export var xxs = "_8p-2";
export var yellow = "_8p-e";